<script>
/**
 * ****************************************************************************
 * @description     :   Zip code Component
 * @created at      :   2023/07/17
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash-uuid';
import repository from '@/utils/repository';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of zip code component
 */
var AnsZipCode = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        inputClass: String,
        buttonClass: String,
        labelClass: String,
        value: String | Number,
        modelValue: String | Number,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        onChange: Function,
        onClick: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            newId: _.uuid(),
            newId2: _.uuid(),
            value1: '',
            value2: ''
        };
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
            this.newId2 = this.id + '_part2';
        }
    },
    computed: {
        viewValue() {
            return this.modelValue ? this.modelValue : this.value;
        },
        viewValue1: {
            get() {
                const val = this.viewValue;
                const vals = val?.split('-');
                if (vals?.length > 1) {
                    return vals[0];
                } else if (val?.length > 0) {
                    return val.substring(0, val.length > 3 ? 3 : val.length);
                }
                return '';
            },
            set() {}
        },
        viewValue2: {
            get() {
                const val = this.viewValue;
                const vals = val?.split('-');
                if (vals?.length > 1) {
                    return vals[1];
                } else if (val?.length > 3) {
                    return val.substring(3, val.length > 7 ? 7 : val.length);
                }
                return '';
            },
            set() {}
        },
        isDisabledButton() {
            return (
                this.isDisabled ||
                this.isReadonly ||
                this.viewValue1.length < 3 ||
                this.viewValue2.length < 4
            );
        }
    },
    methods: {
        /**
         * event block key on input
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        inputOnlyNumber(e) {
            if (
                !(
                    (e.keyCode > 47 && e.keyCode < 58) ||
                    (e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 13
                ) ||
                e.keyCode == 109
            ) {
                e.preventDefault();
                return false;
            }
            return true;
        },
        /**
         * next to input part 2 of zipcode if done part 1
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        netInput(e) {
            if (e.target.value.length == 3) {
                this.$refs.input2.focus();
                this.$refs.input2.setSelectionRange(
                    0,
                    this.$refs.input2.value.length
                );
            }
        },
        /**
         * prev to input part 1 of zipcode if delete all part 2
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        prevInput(e) {
            if (
                (e.keyCode == 8 || e.keyCode == 46) &&
                e.target.value.length == 0
            ) {
                this.$refs.input1.focus();
            }
        },
        /**
         * check paste zipcode on part 1
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        onPaste1(e) {
            e.preventDefault();
            const val = e.clipboardData.getData('text').replace(/\D/g, '');
            let value = val;
            if (val.length > 3) {
                value =
                    val.substring(0, 3) +
                    '-' +
                    val.substring(3, val.length > 7 ? 7 : val.length);
            } else {
                value += '-' + this.$refs.input2.value;
            }
            this.updateInput(value, e);
        },
        /**
         * check paste zipcode on part 2
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        onPaste2(e) {
            e.preventDefault();
            const val = e.clipboardData.getData('text').replace(/\D/g, '');
            const value =
                this.$refs.input1.value +
                '-' +
                val.substring(0, val.length > 4 ? 4 : val.length);
            this.updateInput(value, e);
        },
        /**
         * update part 1 of zipcode
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        updateInput1(e) {
            const value = this.$refs.input1.value + '-' + this.viewValue2;
            this.updateInput(value, e);
        },
        /**
         * update part 2 of zipcode
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        updateInput2(e) {
            const value = this.viewValue1 + '-' + this.$refs.input2.value;
            this.updateInput(value, e);
        },
        /**
         * update model of zipcode
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        updateInput(value, e) {
            this.$emit('update:modelValue', value == '-' ? '' : value);
            if (this.onChange) {
                this.onChange(e, value);
            }
        },
        /**
         * search address by zipcode
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        search() {
            let postalno = this.modelValue;
            postalno = postalno?.replace('-', '');
            repository
                .get(`/common/refer-zip-code?zipcode=${postalno}`)
                .then((res) => {
                    const { data } = res;
                    let address = '';
                    if (data.Code === 200) {
                        address = `${data.Data.address1 ?? ''}${
                            data.Data.address2 ?? ''
                        }${data.Data.address3 ?? ''}`;
                    }
                    if (this.onClick) {
                        this.onClick(address, data.Data);
                    }
                });
        }
    }
};
export default AnsZipCode;
</script>
